export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-960-3e9692f852a4b8090a300db3beb2dc7a.png";